"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCardCheckbox = void 0;
var input_checkbox_1 = require("../../components/input/input.checkbox");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var page_state_1 = require("../../state/page.state");
var tag_icon_1 = require("../tag.icon/tag.icon");
var tag_card_checkbox_style_1 = require("./tag.card.checkbox.style");
(0, theme_1.addStyles)(tag_card_checkbox_style_1.Style);
exports.TagCardCheckbox = {
    view: function (state, selectedState, tag, tagSummary, color) {
        var hasSelections = page_state_1.CurrentState.Tag.tagSize > 0;
        var className = "".concat(tag_card_checkbox_style_1.CSS.container, " ").concat(hasSelections ? tag_card_checkbox_style_1.CSS.hasSelections : '');
        return (0, mithril_1.m)('div', { className: className }, [
            hasSelections ? null : tag_icon_1.TagIcon.view(tag, tagSummary, color),
            input_checkbox_1.CheckBox.view(selectedState)
        ]);
    }
};
//# sourceMappingURL=tag.card.checkbox.js.map